import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CreateTranslateOperationWithConsentMutationVariables = Types.Exact<{
  input: Types.CreateTranslateOperationInput;
}>;


export type CreateTranslateOperationWithConsentMutation = { __typename?: 'Mutation', createTranslateOperationWithConsent?: { __typename?: 'FireflyOperationPayload', fireflyOperation?: { __typename?: 'FireflyOperation', id?: string | null, destination?: { __typename?: 'FolderAsset', id: string } | null } | null } | null };


export const CreateTranslateOperationWithConsent = /*#__PURE__*/ gql`
    mutation CreateTranslateOperationWithConsent($input: CreateTranslateOperationInput!) {
  createTranslateOperationWithConsent(input: $input) {
    fireflyOperation {
      id
      destination {
        id
      }
    }
  }
}
    ` as unknown as DocumentNode<CreateTranslateOperationWithConsentMutation, CreateTranslateOperationWithConsentMutationVariables>;

          

          export const useCreateTranslateOperationWithConsentMutation = (options?:MutationHookOptions<CreateTranslateOperationWithConsentMutation, CreateTranslateOperationWithConsentMutationVariables>) => useMutation(CreateTranslateOperationWithConsent, options);
          

          export type CreateTranslateOperationWithConsentMutationOptions = MutationHookOptions<CreateTranslateOperationWithConsentMutation, CreateTranslateOperationWithConsentMutationVariables>;

          

          export type CreateTranslateOperationWithConsentMutationResult = ReturnType<typeof useCreateTranslateOperationWithConsentMutation>[1];

          
